import { useEffect, useMemo, useState } from 'react';
import useAccountSettings from './useAccountSettings';
import { iconHost, loadSiteIcon, peekSiteIcon } from '../services/siteIcons';

/**
 * Data URL del icono de un sitio, o null mientras carga, si no hay icono o si la cuenta tiene apagado
 * privacy.siteIcons. Sin los ajustes cargados (o si no se pudieron cargar) no se pide nada: ante la
 * duda no sale ninguna peticion. El servidor ademas responde 204 si el ajuste esta apagado.
 */
function useSiteIcon(urlOrHost) {
  const { settings } = useAccountSettings();
  const enabled = settings?.privacy?.siteIcons === true;
  const host = useMemo(() => iconHost(urlOrHost), [urlOrHost]);
  const [src, setSrc] = useState(() => (host ? peekSiteIcon(host) ?? null : null));

  useEffect(() => {
    if (!enabled || !host) { setSrc(null); return undefined; }
    const known = peekSiteIcon(host);
    if (known !== undefined) { setSrc(known); return undefined; }
    let cancelled = false;
    loadSiteIcon(host).then((url) => { if (!cancelled) setSrc(url); });
    return () => { cancelled = true; };
  }, [enabled, host]);

  return enabled && host ? src : null;
}

export default useSiteIcon;
